export default __webpack_public_path__ + "static/media/spark_16.604aaeda.png";